import { useEffect, useState } from 'react';
import { api, type Me } from '../lib/api';

/**
 * Shown for as long as a platform admin is signed in as this user.
 *
 * Unmissable on purpose: whoever is at the screen must never be unsure whose
 * console it is, and everything done here is logged as the admin acting as the
 * user. Ending the session signs the admin out of it and closes the tab the
 * admin panel opened.
 */
export function ImpersonationBanner({ me }: { me: Me }) {
  const imp = me.impersonation;
  const [now, setNow] = useState(() => Date.now());
  const [ending, setEnding] = useState(false);

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 30_000);
    return () => clearInterval(t);
  }, []);

  if (!imp) return null;
  const minutes = Math.max(0, Math.ceil((new Date(imp.expiresAt).getTime() - now) / 60_000));

  const end = async () => {
    setEnding(true);
    await api.logout().catch(() => {});
    /* The admin panel opened this tab; closing it returns them there. */
    window.close();
    window.location.href = '/home';
  };

  return (
    <div className="account-banner" data-tone="impersonate" role="alert">
      <span>
        <strong>Signed in as {me.user?.email}</strong> ({me.user?.role}) by {imp.adminName || imp.adminEmail}
        {imp.reason ? <> · {imp.reason}</> : null} · ends in {minutes} min. Everything here is logged as you.
      </span>
      <button type="button" className="banner-cta" disabled={ending} onClick={() => void end()}>
        {ending ? 'Ending…' : 'End session'}
      </button>
    </div>
  );
}
